import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import CabinetContestMain from "../../components/cabinetContestMain";
import CabinetContestWinners from "../../components/cabinetContestWinners";
import {getContestInfo, getContestWinners, getContestWinnersData} from "../../store/cabinet/action";



const CabinetContestsPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(() => {
        dispatch(getContestWinners());
        dispatch(getContestWinnersData());
        dispatch(getContestInfo());
    }, [dispatch]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <CabinetContestMain/>
                <CabinetContestWinners/>
            </div>
        </section>
    );
};

export default CabinetContestsPage;
